import React from "react";
import classes from "./footerTop.module.css";
import { Link } from "react-router-dom";
import classNames from "classnames";
import { FooterData } from "./footerData";
import { Accordion } from "react-bootstrap";
import { BsTruck } from "react-icons/bs";
import { MdOutlineMailOutline } from "react-icons/md";
import { IoIosCall } from "react-icons/io";
import { useSelector } from "react-redux";

const footerTop = (props) => {
  const { MegaMenuData } = props;
  const { ConfigData } = useSelector((state) => state.homePageSlice);

  return (
    <div className={classes.nav_folderized}>
      <div className={classNames("row", classes.desktopFooter)}>
        <div className={`ftr__list ${classes.nav} col-6 col-md-6 col-lg-3`}>
          <h4>Online Purchase Support</h4>
          <ul>
            {ConfigData?.support_phone && (
              <li>
                <Link
                  to={`tel:+${ConfigData?.support_phone}`}
                  className={classNames(
                    "text-decoration-none",
                    classes.supportLink
                  )}
                >
                  <IoIosCall size={20} />
                  {ConfigData?.support_phone && (
                    <span>{ConfigData?.support_phone} </span>
                  )}
                </Link>
                <p className={classes.supportTime}>{ConfigData?.footer_text}</p>
                {ConfigData?.footer_text && (
                  <p className={classes.supportTime}>(Except Public Holiday)</p>
                )}
              </li>
            )}
            {ConfigData?.support_email && (
              <li>
                <Link
                  to={`mailto:${ConfigData?.support_email}`}
                  className="text-decoration-none"
                >
                  <MdOutlineMailOutline size={20} />
                  <span> {ConfigData?.support_email}</span>
                </Link>
              </li>
            )}
            <li>
              <Link to={"/track-order"} className="text-decoration-none">
                <BsTruck size={20} /> <span>Track Your Order</span>
              </Link>
            </li>
          </ul>
        </div>
        <div className={`ftr__list ${classes.nav} col-6 col-md-6 col-lg-3`}>
          <h4>Quick Links</h4>

          <ul className={classes.firstbox}>
            {MegaMenuData?.category?.children.map((Category, index) => (
              <li key={index}>
                <Link
                  to={
                    Category.name.toLowerCase() === "other categories"
                      ? "/categories"
                      : `/category/${Category.url_path}`
                  }
                  state={{ id: Category.id }}
                  className="text-decoration-none"
                >
                  {Category.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className={`ftr__list ${classes.nav} col-6 col-md-6 col-lg-3`}>
          <h4>Company</h4>
          <ul>
            <li>
              <Link to="/about-us">About Us</Link>
            </li>
            <li>
              <Link to="/faqs">FAQs</Link>
            </li>
            <li>
              <Link to="/contact-us">Contact Us</Link>
            </li>
            <li>
              <Link to="/inspiration-zone-listing">Inspiration Zones</Link>
            </li>
            <li>
              <Link to="/idea-book">Idea Book</Link>
            </li>
            <li>
              <Link to={"/blogs"}>Blogs</Link>
            </li>
            <li>
              <Link to="/catalogue">Catalogues</Link>
            </li>
            <li>
              <Link to={"/bulk-enquiry"}>Bulk Enquiry</Link>
            </li>
            <li>
              <Link to={"/news"}>News & Media</Link>
            </li>
            {/* <li>
              <Link to={"/dealer-locator"}>Dealer Locator</Link>
            </li> */}
          </ul>
        </div>

        <div className={`ftr__list ${classes.nav} col-6 col-md-6 col-lg-3`}>
          <h4>Policy Information</h4>
          <ul>
            <li>
              <Link to="/replacement-and-cancellation">
                Replacement & Cancellation
              </Link>
            </li>
            <li>
              <Link to="/warranty">Warranty</Link>
            </li>
            <li>
              <Link to="/shipping-and-tracking">Shipping and Tracking</Link>
            </li>
            <li>
              <Link to="/privacy-policy"> Privacy Policy</Link>
            </li>
            <li>
              <Link to="/terms-of-use"> Terms of Use</Link>
            </li>
            <li>
              <Link to={"/grievance-redressal"}>Grievance Redressal</Link>
            </li>
            {/* <li>
              <Link to={"/buying-guide"}>Buying Guide</Link>
            </li> */}
          </ul>
        </div>
      </div>

      <div className={classes.mobileFooter}>
        <Accordion flush>
          {FooterData.map((item, idx) =>
            item.label === "Quick Links" ? (
              <Accordion.Item
                key={idx}
                eventKey={`${idx}`}
                className={classes.accordionItem}
              >
                <Accordion.Header className={classes.accordionHeader}>
                  {item.label}
                </Accordion.Header>
                <Accordion.Body className={classes.accordionBody}>
                  {MegaMenuData &&
                  MegaMenuData.category &&
                  MegaMenuData.category.children &&
                  MegaMenuData.category.children.slice(
                    Math.floor(MegaMenuData.category.children.length / 2),
                    MegaMenuData.category.children.length
                  ).length > 0 ? (
                    <div className={classes.quickLinksFooter}>
                      <ul className={classes.firstbox}>
                        {MegaMenuData?.category?.children
                          .slice(
                            0,
                            MegaMenuData.category.children.length > 6
                              ? Math.floor(
                                  MegaMenuData.category.children.length / 2
                                )
                              : MegaMenuData.category.children.length
                          )
                          .map((Category, index) => (
                            <li key={index}>
                              <Link
                                to={
                                  Category.name.toLowerCase() ===
                                  "other categories"
                                    ? "/categories"
                                    : `/category/${Category.url_path}`
                                }
                                state={{ id: Category.id }}
                                className="text-decoration-none"
                              >
                                {Category.name}
                              </Link>
                            </li>
                          ))}
                      </ul>
                      <ul>
                        {MegaMenuData.category.children
                          .slice(
                            Math.floor(
                              MegaMenuData.category.children.length / 2
                            ),
                            MegaMenuData.category.children.length
                          )
                          .map((item, idx) => (
                            <li key={idx}>
                              <Link
                                to={
                                  item.name.toLowerCase() === "other categories"
                                    ? "/categories"
                                    : `/category/${item.url_path}`
                                }
                                state={{ id: item.id }}
                                className="text-decoration-none"
                              >
                                {item.name}
                              </Link>
                            </li>
                          ))}
                      </ul>
                    </div>
                  ) : null}
                </Accordion.Body>
              </Accordion.Item>
            ) : item.label === "Online Purchase Support" ? (
              <Accordion.Item
                key={idx}
                eventKey={`${idx}`}
                className={classes.accordionItem}
              >
                <Accordion.Header className={classes.accordionHeader}>
                  {item.label}
                </Accordion.Header>
                <Accordion.Body className={classes.accordionBody}>
                  <ul>
                    {ConfigData?.support_phone && (
                      <li>
                        <Link
                          to={`tel:+${ConfigData?.support_phone}`}
                          className={classNames(
                            "text-decoration-none",
                            classes.supportLink
                          )}
                        >
                          <IoIosCall size={20} />
                          {ConfigData?.support_phone && (
                            <span>{ConfigData?.support_phone} </span>
                          )}
                        </Link>
                        <p className={classes.supportTime}>
                          {ConfigData?.footer_text}
                        </p>
                        {ConfigData?.footer_text && (
                          <p className={classes.supportTime}>
                            (Except Public Holiday)
                          </p>
                        )}
                      </li>
                    )}
                    {ConfigData?.support_email && (
                      <li>
                        <Link
                          to={`mailto:${ConfigData?.support_email}`}
                          className="text-decoration-none"
                        >
                          <MdOutlineMailOutline size={20} />
                          <span> {ConfigData?.support_email}</span>
                        </Link>
                      </li>
                    )}
                    <li>
                      <Link
                        to={"/track-order"}
                        className="text-decoration-none"
                      >
                        <BsTruck size={20} /> <span>Track Your Order</span>
                      </Link>
                    </li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
            ) : (
              <Accordion.Item
                key={idx}
                eventKey={`${idx}`}
                className={classes.accordionItem}
              >
                <Accordion.Header className={classes.accordionHeader}>
                  {item.label}
                </Accordion.Header>
                <Accordion.Body className={classes.accordionBody}>
                  <ul>
                    {item.children.map((child, index) => (
                      <li key={index}>
                        <Link
                          to={child.link}
                          target={"target" in child ? child.target : "_self"}
                        >
                          {child.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
            )
          )}
        </Accordion>
      </div>
    </div>
  );
};

export default footerTop;
